<template>
  <div class="container">
    <div class="row">
      <div
        id="return-viviet"
        class="col-12">
        <div class="w-100 text-center">
          <div v-if="is_success">
            <div class="check_mark">
              <div class="sa-icon sa-success animate">
                <span class="sa-line sa-tip animateSuccessTip"/>
                <span class="sa-line sa-long animateSuccessLong"/>
                <div class="sa-placeholder"/>
                <div class="sa-fix"/>
              </div>
            </div>
            <h4 class="success">{{ message }}</h4>
            <h4>Xin cảm ơn quý khách !</h4>
          </div>
          <div
            v-else
            class="w-100">
            <center>
              <i
                class="fa fa-exclamation-circle"
                aria-hidden="true"/>
              <h4 class="warning">{{ message }}</h4>
            </center>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import rf from '../../communicate/RequestFactory'

  export default {
    name: 'WalletFeeback',
    data () {
      return {
        is_success: false,
        amount: this.$route.query.amount,
        message: this.$route.query.message,
        payment_type: this.$route.query.payment_type,
        reference_number: this.$route.query.reference_number,
        status: this.$route.query.status,
        trans_ref_no: this.$route.query.trans_ref_no,
        website_id: this.$route.query.website_id,
        signature: this.$route.query.signature
      }
    },

    mounted () {
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      this.phone = params.get("amount");
      this.message = params.get("message");
      this.payment_type = params.get("payment_type");
      this.reference_number = params.get("reference_number");
      this.status = params.get("status");
      this.trans_ref_no = params.get("trans_ref_no");
      this.website_id = params.get("website_id");
      this.signature = params.get("signature");
      this.is_success = true;
      if(this.status === '1' || this.status === 1) {
        this.message = 'Giao dịch thành công';
      } else {
        this.message = 'Giao dịch thất bại!';
      }

      this.updatePayment();
    },

    methods: {
      updatePayment () {
        const data = {
          amount: this.amount,
          message: this.message,
          payment_type: this.payment_type,
          reference_number: this.reference_number,
          status: this.status,
          trans_ref_no: this.trans_ref_no,
          website_id: this.website_id,
          signature: this.signature
        }
        this.$Progress.start();
        rf.getRequest('OrderRequest').updateStateForVTC(data).then((res) => {
          this.$Progress.finish();
          if (res.status === 200) {
            this.$router.push('/')
          }
        }).catch(err => {
          this.$Progress.finish();
        })
      }
    }
  }
</script>

<style scoped>
  .sa-icon {
    width: 80px;
    height: 80px;
    border: 4px solid gray;
    -webkit-border-radius: 40px;
    border-radius: 50%;
    margin: 20px auto;
    padding: 0;
    position: relative;
    box-sizing: content-box;
  }

  .sa-failed {
    border-color: orangered;
  }

  .sa-icon.sa-success {
    border-color: #4CAF50;
  }

  .sa-icon.sa-success::before, .sa-icon.sa-success::after {
    content: '';
    -webkit-border-radius: 40px;
    border-radius: 50%;
    position: absolute;
    width: 60px;
    height: 120px;
    background: white;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .sa-icon.sa-success::before {
    -webkit-border-radius: 120px 0 0 120px;
    border-radius: 120px 0 0 120px;
    top: -7px;
    left: -33px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: 60px 60px;
    transform-origin: 60px 60px;
  }

  .sa-icon.sa-success::after {
    -webkit-border-radius: 0 120px 120px 0;
    border-radius: 0 120px 120px 0;
    top: -11px;
    left: 30px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
    -webkit-transform-origin: 0px 60px;
    transform-origin: 0px 60px;
  }

  .sa-icon.sa-success .sa-placeholder {
    width: 80px;
    height: 80px;
    border: 4px solid #00c853;
    -webkit-border-radius: 40px;
    border-radius: 40px;
    border-radius: 50%;
    box-sizing: content-box;
    position: absolute;
    left: -4px;
    top: -4px;
    z-index: 2;
  }

  .sa-icon.sa-success .sa-fix {
    width: 5px;
    height: 90px;
    background-color: white;
    position: absolute;
    left: 28px;
    top: 8px;
    z-index: 1;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  .sa-icon.sa-success.animate::after {
    -webkit-animation: rotatePlaceholder 4.25s ease-in;
    animation: rotatePlaceholder 4.25s ease-in;
  }

  .sa-icon.sa-success {
    border-color: transparent \9;
  }

  .sa-icon.sa-success .sa-line.sa-tip {
    -ms-transform: rotate(45deg) \9;
  }

  .sa-icon.sa-success .sa-line.sa-long {
    -ms-transform: rotate(-45deg) \9;
  }

  .animateSuccessTip {
    -webkit-animation: animateSuccessTip 0.75s;
    animation: animateSuccessTip 0.75s;
  }

  .animateSuccessLong {
    -webkit-animation: animateSuccessLong 0.75s;
    animation: animateSuccessLong 0.75s;
  }

  @-webkit-keyframes animateSuccessLong {
    0% {
      width: 0;
      right: 46px;
      top: 54px;
    }
    65% {
      width: 0;
      right: 46px;
      top: 54px;
    }
    84% {
      width: 55px;
      right: 0px;
      top: 35px;
    }
    100% {
      width: 47px;
      right: 8px;
      top: 38px;
    }
  }

  @-webkit-keyframes animateSuccessTip {
    0% {
      width: 0;
      left: 1px;
      top: 19px;
    }
    54% {
      width: 0;
      left: 1px;
      top: 19px;
    }
    70% {
      width: 50px;
      left: -8px;
      top: 37px;
    }
    84% {
      width: 17px;
      left: 21px;
      top: 48px;
    }
    100% {
      width: 25px;
      left: 14px;
      top: 45px;
    }
  }

  @keyframes animateSuccessTip {
    0% {
      width: 0;
      left: 1px;
      top: 19px;
    }
    54% {
      width: 0;
      left: 1px;
      top: 19px;
    }
    70% {
      width: 50px;
      left: -8px;
      top: 37px;
    }
    84% {
      width: 17px;
      left: 21px;
      top: 48px;
    }
    100% {
      width: 25px;
      left: 14px;
      top: 45px;
    }
  }

  @keyframes animateSuccessLong {
    0% {
      width: 0;
      right: 46px;
      top: 54px;
    }
    65% {
      width: 0;
      right: 46px;
      top: 54px;
    }
    84% {
      width: 55px;
      right: 0px;
      top: 35px;
    }
    100% {
      width: 47px;
      right: 8px;
      top: 38px;
    }
  }

  .sa-icon.sa-success .sa-line {
    height: 5px;
    background-color: #4CAF50;
    display: block;
    border-radius: 2px;
    position: absolute;
    z-index: 2;
  }

  .sa-icon.sa-success .sa-line.sa-tip {
    width: 25px;
    left: 14px;
    top: 46px;
    -webkit-transform: rotate(45deg);
    transform: rotate(45deg);
  }

  .sa-icon.sa-success .sa-line.sa-long {
    width: 47px;
    right: 8px;
    top: 38px;
    -webkit-transform: rotate(-45deg);
    transform: rotate(-45deg);
  }

  .fa-exclamation-circle {
    color: #ff6d00;
    font-size: 100px;

  }

  @-webkit-keyframes rotatePlaceholder {
    0% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    5% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    12% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
    100% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
  }

  @keyframes rotatePlaceholder {
    0% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    5% {
      transform: rotate(-45deg);
      -webkit-transform: rotate(-45deg);
    }
    12% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
    100% {
      transform: rotate(-405deg);
      -webkit-transform: rotate(-405deg);
    }
  }

  #subscription_success .modal-content .close {
    position: relative;
    top: 0;
    right: 12px;
    font-size: 30px;
  }

  #noti_app .modal-content .close {
    position: relative;
    top: 5px;
    right: 12px;
    font-size: 30px;
  }

  #subscription_success h4, #subscription_failed h4, #noti_app h4 {
    font-family: r-light;
    margin-top: -5px;
    padding-bottom: 15px;
  }

  #noti_app h3 {
    font-family: r-light;
    color: #d80410;
    margin-top: 10px;
  }

  #noti_app h5 {
    font-size: 15px;
  }

  #noti_app .img_app_dowload a img {
    width: 30%;
    padding-bottom: 30px;
  }

  .img_app_dowload a img {
    width: 40%;
  }

  #subscription_failed .modal-content {
    padding: 20px 0 0 0;
  }

  #subscription_failed .modal-content .close {
    position: relative;
    top: -20px;
    right: 8px;
    font-size: 30px;
  }

  #subscription_failed .check_mark_faile {
    margin-bottom: 20px;
  }

  .ios-viviet a img {
    width: 60%;
    margin: 5px 0;
  }

  .ios-viviet1 {
    width: 100%;
    height: auto;
    clear: both;
  }

  .ios-viviet1 a img {
    width: 60%;
    height: auto;
    clear: both;
    margin: 10px 0;
  }

  #return-viviet {
    background-color: #fff;
    margin-top: 10px;
    margin-bottom: 30px;

  }

  #return-viviet .text-content {
    text-align: center;
    line-height: 20px;
    margin-bottom: 10px;
  }

  #return-viviet .text-content a {
    color: #fff;
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/feedback/WalletFeeback.vue